'use es6';

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import unescapedText from 'I18n/utils/unescapedText';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { AddIcon } from 'foundations-assets';
import MenuNodeTypes from 'simple-menus-core/enums/MenuNodeTypes';
import * as MenuTreeActions from 'simple-menus-core/actions/MenuTree';
import UsageTracker from 'simple-menus-lib/utils/usageTracker/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const actions = [MenuNodeTypes.NO_LINK, MenuNodeTypes.PAGE_LINK, MenuNodeTypes.PAGE_LINK_WITH_PARAMS, MenuNodeTypes.URL_LINK];
function AddMenuButton({
  menuId
}) {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => {
    setIsOpen(false);
  };
  const handleDropdownChange = evt => {
    const {
      value
    } = evt.target;
    setIsOpen(value || !isOpen);
  };
  const handleNodeCreate = type => () => {
    dispatch(MenuTreeActions.addNodeToBottom(menuId, {
      type
    }));
    UsageTracker.track('addMenuItem', {
      type,
      method: 'button'
    });
    closeMenu();
  };
  return /*#__PURE__*/_jsx(Dropdown, {
    arrowSize: "small",
    buttonText: unescapedText('simpleMenusLib.components.addMenuButton.label'),
    buttonSize: "small",
    buttonUse: "link",
    icon: AddIcon,
    caretRenderer: null,
    open: isOpen,
    onOpenChange: handleDropdownChange,
    closeOnOutsideClick: true,
    children: /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: actions.map(action => {
        return /*#__PURE__*/_jsx(Button, {
          onClick: handleNodeCreate(action),
          use: "unstyled",
          children: unescapedText(`simpleMenusLib.components.addMenuButton.actions.${action}`)
        }, action);
      })
    })
  });
}
export default AddMenuButton;